import { Box } from "@mui/material";
import size from "lodash/size";
import { Suspense } from "react";
import EnhancedCommentItemRenderer from "../../../_src_shared/comments/EnhancedCommentItemRenderer";
import LoadingFallback from "../../LoadingFallback";
import SideCardModal from "../../modals/SideCardModal";
import LoanEnhancedCommentTextBox from "./LoanEnhancedCommentTextBox";

const LoanCommentsSideCardPreview = ({ show, onClose, loan, comments }) => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <SideCardModal
        title={`Loan Comments (${size(comments)})`}
        show={show}
        onClose={onClose}
        suppressBodyPadding
        bodySx={{ pt: 1.5, position: "relative" }}
      >
        <Box sx={{ px: 2 }}>
          <LoanEnhancedCommentTextBox loan={loan} />
        </Box>
        <EnhancedCommentItemRenderer
          padding={0}
          sx={{ p: 2 }}
          loan={loan}
          comments={loan?.comments}
        />
      </SideCardModal>
    </Suspense>
  );
};

export default LoanCommentsSideCardPreview;
